<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getJNJTJTConfigure, queryDisplayCycle, getStopRecordingToConfigure } from '@/api/park'
import { setLocalStorage } from "@/utils/auth"
import { currentTimeStamp } from "@/api/system/tool"
import config from '@/config/index'
export default {
  name: 'App',
  mounted () {
    if (this.$enumObject.providerConfig[config.projectName].gateway) {
      currentTimeStamp().then(res => {
        if (res.status === 1001) {
          let timestamp = res.body; //服务器时间戳
          let myDate = new Date().getTime(); //本地时间戳
          let dateDiff = timestamp - myDate; //求差值
          setLocalStorage("dateDiff", dateDiff); //保存差值
        }
      })
    }
    getJNJTJTConfigure().then(res => {
      this.$store.dispatch('app/SetJntcimg', res.body)
    });
    queryDisplayCycle().then(res => {
      this.$store.dispatch('app/SetChosentime', res.body)
    });
    getStopRecordingToConfigure().then(res => {
      this.$store.dispatch('app/SetImgbtn', res.body)
    })
  }
}
</script>
<style lang="scss">
@import "assets/css/reset";
</style>
